

enum APIRoute {
    signup = '/signup',
    login = "/login",
    confirm_otp = '/otp/verify',
    resend_otp = '/otp/resend',
    password_confirm="/passwd/verify",
    password_reset = "/passwd/reset",
    update_setting="/settings/add",
    customers = "/customers/",
    customers_add = '/customers/add',
    customers_edit = '/customers/edit/',
    customers_search = '/customers/search',
    agents = '/riders/', 
    agents_add = "/riders/add",
    agents_edit = "/riders/edit/",
    price_estimate = '/distance/calc',
    waybill_data = '/package/list',
    waybill_data_edit = '/package/edit/',
    waybill_data_add = "/package/add",
    waybill_data_view = "/package/view/",
    waybill_data_download = "/package/doc/download/",
    waybill_report = '/package/reports',
    
}

enum APPRoute {

    logout = '/logout',
    device = '/device',
    map = '/map',
    team = '/team',
    report ='/report',
    settings='/settings',
    signup = '/signup',
    login= '/',
    otp = "/verification",
    password_confirm = "/password/credential",
    password_reset="/password/reset",
    customer = "/customers", 
    agents = '/agents',
    price_estimate='/shipment/price_estimates',
    packages='/shipment/packages',
    shipments='/shipment/schedules',
    shipment_reports='/shipment/reports'
}

enum RespStatus {

    success = 0, 
    failed = -1 

}


export {

    APPRoute, 
    APIRoute,
    RespStatus

}   